import { Injectable, inject } from '@angular/core';

import {TranslateService} from '@ngx-translate/core';

import {Observable, of} from 'rxjs';

import {TimeService, TransportType} from '@shared';

import {EmployeeService, RouteKeyNumbers} from 'planner-shared';

import {TravelTimeTransport} from '../../models/travel-time-transport';

@Injectable({
    providedIn: 'root'
})
export class TravelTimeTransportService {
    private readonly employeeService = inject(EmployeeService);
    private readonly timeService = inject(TimeService);
    private readonly translationService = inject(TranslateService);


    public mapToTravelTimeTransport(routeKeyNumbers: RouteKeyNumbers[]): Observable<TravelTimeTransport> {
        const travelTimeTransport = this.resetTransportTravelTime();
        routeKeyNumbers.forEach(
            routeKeyNumber => {
                this.employeeService.getEmployee(routeKeyNumber.workHourId)
                    .subscribe(employee => {
                        switch (employee.transport) {
                        case TransportType.Drive:
                            travelTimeTransport.totalTravelTimeCar += routeKeyNumber.totalTravelTimeSeconds;
                            break;
                        case TransportType.Bicycle:
                            travelTimeTransport.totalTravelTimeBike += routeKeyNumber.totalTravelTimeSeconds;
                            break;
                        case TransportType.Walk:
                            travelTimeTransport.totalTravelTimeWalk += routeKeyNumber.totalTravelTimeSeconds;
                            break;
                        }
                    });
            }
        );
        return of(travelTimeTransport);
    }

    public resetTransportTravelTime(): TravelTimeTransport {
        const transportTravelTime = {
            totalTravelTimeBike: 0,
            totalTravelTimeCar: 0,
            totalTravelTimeWalk: 0,
        };
        return transportTravelTime;
    }

    public formatTransportTooltip(travelTimeTransport: TravelTimeTransport): string {
        let tooltip = '';
        let travelTime: {hours: number, minutes: number};
        if (travelTimeTransport.totalTravelTimeCar > 0) {
            travelTime = {
                hours: this.timeService.extractHours(travelTimeTransport.totalTravelTimeCar),
                minutes: this.timeService.extractMinutes(travelTimeTransport.totalTravelTimeCar)
            };
            this.translationService.get('TRAVEL_TIME_OBJECTIVE_INFO_DRIVE',
                {hours: travelTime.hours, minutes: travelTime.minutes})
                .subscribe(translation => tooltip += translation);
        }
        if (travelTimeTransport.totalTravelTimeBike > 0) {
            travelTime = {
                hours: this.timeService.extractHours(travelTimeTransport.totalTravelTimeBike),
                minutes: this.timeService.extractMinutes(travelTimeTransport.totalTravelTimeBike)
            };
            this.translationService.get('TRAVEL_TIME_OBJECTIVE_INFO_BIKE',
                {hours: travelTime.hours, minutes: travelTime.minutes})
                .subscribe(translation => tooltip += translation);
        }
        if (travelTimeTransport.totalTravelTimeWalk > 0) {
            travelTime = {
                hours: this.timeService.extractHours(travelTimeTransport.totalTravelTimeWalk),
                minutes: this.timeService.extractMinutes(travelTimeTransport.totalTravelTimeWalk)
            };
            this.translationService.get('TRAVEL_TIME_OBJECTIVE_INFO_WALK',
                {hours: travelTime.hours, minutes: travelTime.minutes})
                .subscribe(translation => tooltip += translation);
        }
        return tooltip;
    }
}
